import * as React from 'react';
import styled from 'styled-components';
import Checkbox from './../components/checkbox/Checkbox';
import SelectInput from './../components/SelectInput';
import TextInput from './../components/TextInput';

const MultiCheckBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 14px;
`;

export const renderAttributeInfo = (metaData, value, t, products) => {
    switch (metaData.renderType) {
        case 'select':
            return (
                <span>
                    {t(metaData.dictionary[value]) || '-'}
                </span>
            )
        case 'datetime':
            return (
                <span>
                    {value
                        ? value.replace("T", " ").substring(0, 19)
                        : "-"
                    }
                </span>
            )
        case 'numeric':
            return (
                <span>
                    {`${value || '-'} ${value ? metaData.unit : ""}`}
                </span>
            )
        case 'multicheckbox':
            value = value ? value : [];
            return (
                <span>
                    {value.map(p => { return products ? t(products.find(pr => pr.id === p.productId).name) : '' })
                        .toString()
                        .split(',').join(', ')}
                </span>
            )
        case 'link':
            const prettyValue = value
                ? value
                    .replace('http://', '')
                    .replace('www.', '')
                : value;
            const dotIndex = prettyValue ? prettyValue.indexOf('.') : 0;
            return (
                value
                    ? <a href={value} target='_blank' onClick={() => { window.open(value, '_blank'); }}>
                        {prettyValue.slice(0, dotIndex)}
                    </a>
                    : <span>-</span>
            )
        default:
            return (
                <span>
                    {value || '-'}
                </span>
            )
    }
};

export const renderAttributeEdit = (id, metaData, attributeValue, onAttributeChange, t, products) => {
    let value = attributeValue;
    
    const { placeholder, dictionary, isEditable, renderType, tip } = metaData
    if (isEditable) {
        switch (renderType) {
            case 'select':
                value = value ? value : '';
                return (
                    <SelectInput
                        style={{ alignItems: 'flex-start' }}
                        tip={t(tip) || null}
                        onChange={
                            (event, cellInfo) => { onAttributeChange(event.target.value) }
                        }
                        value={value}>
                        {Object.keys(dictionary)
                            .map(
                                dictKey => {
                                return (
                                    <option
                                        key={dictKey}
                                        value={dictKey}>
                                        {t(dictionary[dictKey])}
                                    </option>
                                )
                            })
                        }
                    </SelectInput>
                )
            case 'datetime':
                const formatedValue = value ? value.substring(0, 10) : '';
                return (
                    <TextInput
                        style={{ alignItems: 'flex-start' }}
                        tip={t(tip) || null}
                        onChange={
                            (event, cellInfo) => { onAttributeChange(event.target.value) }
                        }
                        type='date'
                        value={formatedValue || ''}
                        placeholder='2017-06-20' />
                )
            case 'multicheckbox':
                value = value ? value : [];
                products = products ? products : [];
                return <MultiCheckBox>{products.map(p => {
                    return (
                        <Checkbox
                            key={`multiCheckBox_${p.id}`}
                            onClick={
                                (event, cellInfo) => {
                                    if (value.some(v => v.productId === p.id)) {
                                        value.splice(value.findIndex(v => v.productId === p.id), 1);
                                    } else {
                                        value.push({ projectId: id, productId: p.id });
                                    }
                                    onAttributeChange(value)
                                }
                            }
                            checked={value.some(v => v.productId === p.id)}
                            label={t(p.name)} />
                    )
                })}</MultiCheckBox>
            case 'numeric':
                return <TextInput
                    style={{ alignItems: 'flex-start' }}
                    tip={t(tip) || null}
                    onChange={
                        (event, cellInfo) => { onAttributeChange(event.target.value) }
                    }
                    type='number'
                    value={value || ''}
                    placeholder={placeholder || ''} />
            default: 
                return <TextInput
                    style={{ alignItems: 'flex-start' }}
                    tip={t(tip) || null}
                    onChange={
                        (event, cellInfo) => { onAttributeChange(event.target.value) }
                    }
                    type='text'
                    value={value || ''}
                    placeholder={placeholder || ''} />
        }
    }
    else {
        return renderAttributeInfo(metaData, value);
    }
};


// WEBPACK FOOTER //
// ./src/utilities/renderAttributes.jsx